module.exports = __webpack_public_path__ + "img/legal_products_header_1.107ab514.png";